import * as React from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { BreakSettingsType } from 'modules/attendance/hooks/useFetchBreakSettings'
import { TimeSettingsBreakConfigs } from 'modules/attendance/hooks/useFetchTimeSettingsBreakConfigurations'
import BreakSettingsForm from 'modules/attendance/lib/forms/BreakSettingForm'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import AutomaticBreak from './AutomaticBreak'
import ManualBreak from './ManualBreak'
import RestAlerts from './RestAlerts'

interface Props {
  attendanceSetting: AttendanceSetting
  breakSettings: BreakSettingsType[]
  timeSettingsBreakConfigurations: TimeSettingsBreakConfigs[]
  refetch: () => void
}

const Breaks = ({
  attendanceSetting,
  breakSettings,
  timeSettingsBreakConfigurations,
  refetch,
}: Props) => {
  const breakSetting = breakSettings.find(
    (setting) => setting.id === attendanceSetting?.breakSettingId
  )

  const settingForm = BreakSettingsForm({
    settingId: attendanceSetting?.id,
    breakSettingId: attendanceSetting?.breakSettingId,
    breakSetting: breakSetting,
  })

  return (
    <>
      <Section
        illustration="coffee"
        title={i18n.t('time_tracking.settings.tabs.breaks')}
        description={i18n.t('time_tracking.settings.breaks.description')}
      >
        <Box gap="s24">
          <ManualBreak
            attendanceSetting={attendanceSetting}
            timeSettingsBreakConfigurations={timeSettingsBreakConfigurations}
            settingForm={settingForm}
            refetch={refetch}
          />

          <AutomaticBreak
            attendanceSetting={attendanceSetting}
            breakSetting={breakSetting}
            timeSettingsBreakConfigurations={timeSettingsBreakConfigurations}
            settingForm={settingForm}
            refetch={refetch}
          />
        </Box>
      </Section>
      <RestAlerts
        attendanceSetting={attendanceSetting}
        breakSetting={breakSetting}
        timeSettingsBreakConfigurations={timeSettingsBreakConfigurations}
        settingForm={settingForm}
        refetch={refetch}
      />
    </>
  )
}

export default observer(Breaks)
